<script setup lang="ts">
import type { SlugBodyItem } from '~/components/slug/body';

useSeoMeta({
  title: 'Fitness | Okgym - Fitcentrum | Pardubický Kraj',
  description:
    'Fitness, Gym, Solarium, Box - Lepší nabídku nenajdeš! Pro studenty zvýhodněná nabídka jen v Okgym',
});

const services: SlugBodyItem[] = [
  {
    title: 'Špičkově vybavená posilovna',
    description:
      'Naše plně klimatizovaná posilovna o rozloze téměř 800 m² s více než 90 stanovišti je rozdělena do funkčních zón: kardiozóna (běžecké pásy, eliptické trenažéry, nekonečné schody, Air biky), zóna posilovacích strojů (60 strojů a 2 multifunkční věže), zóna volných vah s 60 jednoručkami a funkční a strečinková zóna s power racky, TRX a kettlebelly. Součástí je i odpočinková zóna s nabídkou proteinových nápojů a zdravých svačin.',
    image: {
      url: '/images/fitness/vybaveni.webp',
      alt: 'Špičkově vybavená posilovna',
    },
  },
  {
    title: 'Boxerský sál a další aktivity',
    description:
      'Pro milovníky bojových sportů máme k dispozici špičkový boxerský sál o rozloze 700 m². Najdeš v něm profesionální ring, několik boxovacích pytlů, lapy a další vybavení. Podlaha je tvořena 6 cm tatami pro maximální komfort a bezpečnost. Můžeš se také zapojit do tréninků thajského boxu, kondičního cvičení v aerobním sále nebo spinningu.',
    image: {
      url: '/images/fitness/box.webp',
      alt: 'Boxerský sál',
    },
  },
  {
    title: 'Solárium a relaxace',
    description:
      'Po náročném tréninku si u nás můžeš dát saunu, úžasnou masáž nebo navštívit solárium. Naše solárium Ergoline Inspiration 400 Super Power krásně opaluje a je navíc vybaveno trubicemi, které podporují tvorbu kolagenu. Kosmetické přípravky před i po opalování lze zakoupit přímo na recepci.',
    image: {
      url: '/images/solarium/2.webp',
      alt: 'Solárium a relax',
    },
  },
];

const text = {
  title: 'Přijď si zacvičit do přátelského prostředí.',
  subtitle: 'FITNESS CENTRUM',
  description:
    'Místo, kde se i jako nováček budeš cítit naprosto přirozeně. Všichni se k sobě chováme slušně, jsme na stejné vlně a nikoho nesoudíme – ať máš nadváhu, nebo ti je 60 let. Každý má u nás své místo. A pokud nevíš, jak začít – máš u nás první trénink s trenérem úplně zdarma! Přijímáme karty Multisport, Benefity, Benefit plus, Pluxee, UP ČR. Parkování přímo u fitcentra je zdarma.',
} as const;
</script>

<template>
  <PageContainer no-alignment no-padding>
    <SlugHeader
      :title="text.title"
      :subtitle="text.subtitle"
      :description="text.description"
      icon="icon:fitcenter"
      :image-header="{
        url: '/images/fitness/header.webp',
        alt: 'Lezecká stěna',
      }"
      :links="[
        {
          to: '/cenik-fitko-vstupy-1789421649204.pdf',
          label: 'Ceník vstupy',
          icon: 'icon:document',
        },
      ]"
    />
    <SlugBody :items="services" />
    <Feed />
    <IndexGallery />
  </PageContainer>
</template>
